/*= ========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VueClipboard from 'vue-clipboard2';
import VeeValidate from 'vee-validate';
import VTour from 'vue-tour';
import {
  ToastPlugin, ModalPlugin, BootstrapVue, BootstrapVueIcons,
} from 'bootstrap-vue';

import VxTooltip from './layouts/components/vx-tooltip/VxTooltip';
import VxCard from './components/vx-card/VxCard';
import VxList from './components/vx-list/VxList';
import VxBreadcrumb from './layouts/components/VxBreadcrumb';
import VxInputGroup from './components/vx-input-group/VxInputGroup';
import HasPermission from './directives/HasPermission';
import InEnvironment from './directives/InEnvironment';

import FeatherIcon from '@core/components/feather-icon/FeatherIcon';
// v-select component
import './libs/vue-select';

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VTour);

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);
Vue.directive('has-permission', HasPermission);
Vue.directive('in-environment', InEnvironment);
Vue.directive('validate', VeeValidate.directive);
// BSV Plugin Registration
Vue.use(VTooltip);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
